import { Button } from "@mui/material"
import React from "react"
import { customPalette } from "../../../../../../../../../../theme"
import { IconUnlink } from "../../../../../../../../../components/custom-icons/icon-unlink"
import { IconLink } from "../../../../../../../../../components/custom-icons/icon-link"

interface IProps {
  isGrouped: boolean
  onClick?(): void
}

export function GroupButton({ isGrouped, onClick }: Readonly<IProps>): React.JSX.Element {
  return (
    <Button
      onClick={onClick}
      sx={{
        color: customPalette.lightBlue2,
        backgroundColor: customPalette.paperBorder,
        borderRadius: 3,
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.08)",
        ":hover": {
          backgroundColor: customPalette.lightGray5,
        },
      }}>
      {isGrouped ? <IconUnlink /> : <IconLink />}
      {isGrouped ? "Dégrouper" : "Grouper"}
    </Button>
  )
}
